import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EnvService } from 'src/services/env.service';

@Injectable({ providedIn: 'root' })
export class ProducerPortalHttpService {
    constructor(
        private http: HttpClient,
        private env: EnvService
    ) {}

    loginToProducerPortal(userId) {
        return this.http.post(`${this.env.EDGE_SERVICE_PATH}/g2-integration/user/${userId}/loginToProducerPortal`, null);
    }
}
